import script from "./DictionaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryView.vue?vue&type=script&setup=true&lang=js"

import "./DictionaryView.vue?vue&type=style&index=0&id=fb903a38&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb903a38"]])

export default __exports__